import { Dialog } from 'primereact/dialog';
import React from 'react';
import {
    Button,
    Form,
    Input
} from 'reactstrap';

import { UploadCloud, FileText } from 'react-feather';
import '../../components/rates/StylePriceUpload.css'

export const ModalUpload = (props) => {

    const {
        UploadExams,
        handleOnChange,
        toggleModalUpload,
        modalUpload,
        fileName,
        removeFile,
        
    } = props;

    
    const footer = (
        <div className='mt-2' style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
            <Button
                color="danger"
                size="sm"
                onClick={toggleModalUpload}
            >
                Cancelar
            </Button>
            <Button
                color="primary"
                size="sm"
                onClick={UploadExams}
            >
                Cargar archivo
            </Button>
        </div>
    );

    return (
        <Dialog
            header="Carga masiva de precios"
            visible={modalUpload}
            onHide={toggleModalUpload}
            closable={true}
            modal
            blockScroll
            className='medium-dialog'
            footer={footer}

        >

            <Form className="upload-form">

                <div className="text-center mb-4">
                    {/* <div className="upload-icon-container">
                        <UploadCloud size={42} />
                    </div> */}

                    <h5 className="mt-3 mb-2 font-weight-bold-upload">
                        Importar lista de precios
                    </h5>

                    <p className="text-muted mb-0">
                        Selecciona un archivo CSV para asignar los precios al tarifario.
                    </p>
                </div>

               <div className="upload-box">

                    <label className="upload-label">

                        <Input
                            accept=".csv"
                            onChange={handleOnChange}
                            type="file"
                            className="d-none"
                            id="upload-csv"
                        />

                        {
                            !fileName ? (

                                <div className="upload-content">

                                    <UploadCloud size={40} />

                                    <span className="mt-2 upload-title">
                                        Seleccionar archivo CSV
                                    </span>

                                    <small className="text-muted">
                                        Haz clic para cargar tu archivo
                                    </small>

                                </div>

                            ) : (

                                <div className="selected-file-container">

                                    <div className="selected-file-info">

                                        <FileText size={34} />

                                        <div className="file-data">
                                            <span className="file-name">
                                                {fileName}
                                            </span>

                                            <small className="text-muted">
                                                Archivo seleccionado correctamente
                                            </small>
                                        </div>

                                    </div>

                                    <button
                                        type="button"
                                        className="remove-file-btn"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            removeFile();
                                        }}
                                    >
                                        <i className="fa fa-trash"></i>
                                    </button>

                                </div>

                            )
                        }

                    </label>

                </div>

            </Form>
        </Dialog>
    )
}